// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "demo" : chunkId) + "-legacy." + {"573":"96895812","594":"d4eb145a","599":"f212b139","604":"b584bed1"}[chunkId] + ".js";
};